import moment from 'moment'

import { getImageById } from '../services/image-caching'

export function getParameterByName(name) {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search)
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
}

export function calendarDateString(month, year) {
	var workingOnDate = new Date(year, month-1, 1)
	return moment(workingOnDate).format("MMMM YYYY")
}

export function calendarMonthName(month) {
	return monthName(month-1)
}

export function monthName(monthIndex) {
	return moment.months(monthIndex)
}

export function daysInMonth(anyDateInMonth) {
	return new Date(anyDateInMonth.getYear(), anyDateInMonth.getMonth() + 1, 0).getDate()
}

export function weeksInMonth(daysInMonth, firstWeekdayOfMonth) {
	return Math.ceil((daysInMonth + firstWeekdayOfMonth) / 7)
}

export const GRID_SEGMENTS = 420
export function gridSegmentsDivided(numberOfDivisons = 7, segments = GRID_SEGMENTS) {
	return segments / numberOfDivisons
}

export function fetchJson(path, method = 'get', body = undefined) {

	// this is required to append cookies
	var config = {
		credentials: 'same-origin',
		method: method,
		body: body
	}

	// send the body as JSON unless it is FormData
	// because FormData may contain an attachment
	if(body !== undefined && !(body instanceof FormData)) {
		config['headers'] = {
			"Content-Type": "application/json; charset=UTF-8"
		}
	}

	// promise that resolves only if successful
	// rejects if we have an error
	return new Promise(async (resolve, reject) => {
		await fetch(path, config)
			.then(response => {
				return response.json();
			}, failure => {
				return { error: true, msg: 'Unexpected network error.'}
			})
			.then(json => {
				// handle error messages
				if (json.error !== undefined && json.error === true) {
					// console.log("Server error: " +  json.msg != null ? json.msg : '')
					reject(json)
					return
				}
				resolve(json)
			})
	}).catch(value => {
		// do nothing
		return value
	})
}

export function urlForImageId(imageId) {
  if (imageId > 0) {
    return '/images/' + imageId + '/data';
  } else {
    return getImageById(imageId);
  }
}

/*
 * Returns an array of every `step` integer starting from `start` and ending
 * with `end` (inclusive). Inspired by range() in Python.
 *
 * Examples:
 *   range(3) # Returns [0, 1, 2, 3]
 *   range(1, 3) # Returns [1, 2, 3]
 *   range(1, 5, 2) # returns [1, 3, 5]
 */
export function range(start, end, step = 1) {
	if (end === undefined) {
		end = start
		start = 0
	}

	let result = []
	for (let i = start; i <= end; i += step) {
		result.push(i)
	}
	return result
}

// http://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

// http://stackoverflow.com/q/1643320/104184
export function getMonthName(date) {
	let monthNames = [
		'January', 'February', 'March', 'April', 'May', 'June',	'July',
		'August', 'September', 'October', 'November', 'December'
	]
	return monthNames[date.getMonth()]
}

export function displayLoading(isDisplayed) {
	if (isDisplayed) {
		if ("block" !== document.getElementById("loading").style.display) {
			document.getElementById("loading").style.display = "block";
		}
	} else {
		document.getElementById("loading").style.display = "none";
	}
};

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function convertImageToBase64(image) {
  const buffer = Buffer.from(await new Response(image).arrayBuffer());
  return `data:${image.type};base64,${buffer.toString('base64')}`;
}

export function convertBase64ToBlob(base64Image) {
  // Split into two parts
  const parts = base64Image.split(';base64,');

  // Hold the content type
  const imageType = parts[0].split(':')[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
}

export function getLastSaved(modified) {
  const start = moment(new Date(modified + ' GMT'));
  const end = moment(new Date());

  const minutesDiff = end.diff(start, 'minutes');
  if (minutesDiff < 60) {
    if (minutesDiff < 1) {
      return `< 1 min ago`;
    } else {
      return `${minutesDiff} min ago`;
    }
  } else {
    const hoursDiff = end.diff(start, 'hours');
    if (hoursDiff < 24) {
      return `${hoursDiff} ${hoursDiff < 2 ? 'hr' : 'hrs'} ago`;
    } else {
      const daysDiff = end.diff(start, 'days');
      if (daysDiff < 7) {
        return `${daysDiff} ${daysDiff < 2 ? 'day' : 'days'} ago`;
      } else {
        const monthsDiff = end.diff(start, 'months');
        if (monthsDiff < 1) {
          const weeksDiff = end.diff(start, 'weeks');
          return `${weeksDiff} ${weeksDiff < 2 ? 'week' : 'weeks'} ago`;
        } else if (monthsDiff < 12) {
          return `${monthsDiff} ${monthsDiff < 2 ? 'month' : 'months'} ago`;
        } else if (monthsDiff === 12 && (moment(start).add(1, 'years').isSame(end))) {
          return `1 year ago`;
        } else {
          return `> 1 year ago`;
        }
      }
    }
  }
}

/**
 * Modify HTML to add 'target="_blank"' to links so they open in new tabs by default.
 * @param {string} htmlText - HTML to be modified.
 * @return {string} The modified HTML text.
 */
export function addAnchorTargetBlank(htmlText) {
  var match;
  var anchorToExternalRegex = new RegExp(/(<a.*?https?:\/\/.*?[^a]>)+?/g);
  while ((match = anchorToExternalRegex.exec(htmlText)) !== null) {
      // With only one capture group in the RegExp, we can safely take the first index from the match.
      var linkString = match[0];

      if (linkString.indexOf('target=') === -1) {
          var fixedLinkString = linkString.replace(/>$/, ' target="_blank">');
          htmlText = htmlText.replace(linkString, fixedLinkString);
      }
  }
  return htmlText;
}

/**
* Modify HTML to remove the list-style when rendering checkboxes.
* @param {string} htmlText - HTML to be modified.
* @return {string} The modified HTML text.
*/
export function removeListStyleWhenCheckbox(htmlText) {
  var parser = new DOMParser();
  var htmlDoc = parser.parseFromString(htmlText, 'text/html');
  var listItems = htmlDoc.getElementsByTagName('li');

  for (var i = 0; i < listItems.length; i++) {
      var listItem = listItems[i];

      for (var j = 0; j < listItem.children.length; j++) {
          var listItemChild = listItem.children[j];

          if (listItemChild instanceof HTMLInputElement && listItemChild.type === 'checkbox') {
              // From Github: margin: 0 .2em .25em -1.6em;
              listItem.style.marginLeft = '-1.5em';
              listItem.style.listStyleType = 'none';
          }
      }
  }

  return htmlDoc.documentElement.innerHTML;
}

export function getStorageItem(key) {
  let value = new Map();
  if (localStorage.getItem(key)) {
    value = new Map(JSON.parse(localStorage.getItem(key)));
  }
  return value;
}

export function setStorageItem(key, value) {
  localStorage.setItem(key, JSON.stringify(Array.from(value.entries())));
}



// WEBPACK FOOTER //
// ./src/lib/ACHelpers.js